const $userCanEditMedia = {
  methods: {
    $userCanEditMedia () {
      try {
        return this.$userHasRoles(['admin', 'media'])
      } catch (err) {
        console.log('userCanEditMedia mixin error', err)
        return false
      }
    }
  }
}

export {
  $userCanEditMedia
}
